import GameplayHeader from "@/components/game/header/GameplayHeader";
import SpinView from "@/components/game/spin/SpinView";
import store from "@/store";

export default [
	{
		path: "spin",
		components: {
			gameSpace: SpinView,
			gameHeader: GameplayHeader,
		},
		beforeEnter(to, from, next) {
			store.dispatch("game/plans/deselect");
			next();
		},
	},
	{
		path: "/spin/complete",
		beforeEnter(to, from, next) {
			next({ path: "/game/spin" });
		},
	},
];
